import { SimpleIconProps } from '../types';

import colors from 'styles/core/colors.module.scss';

export const IconPen = ({
  className,
  color = colors.blueGray700,
  ...svgProps
}: SimpleIconProps) => (
  <svg
    {...svgProps}
    className={className}
    fill="none"
    height="14"
    role="img"
    viewBox="0 0 14 14"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M1.75 10.062V12.2495H3.9375L10.3892 5.79784L8.20167 3.61034L1.75 10.062ZM12.0808 4.10617C12.3083 3.87867 12.3083 3.51117 12.0808 3.28367L10.7158 1.91867C10.4883 1.69117 10.1208 1.69117 9.89333 1.91867L8.82583 2.98617L11.0133 5.17367L12.0808 4.10617Z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);
